import React from 'react'
import './contactUs.css';
import { MapPin, Phone, Mail, Globe, Facebook, Youtube, Instagram } from "lucide-react";
import { Link } from 'react-router-dom';
import SEO from './SEO';

const ContactUs = () => {
  return (
    <div>

      <SEO
        title="Contact Us"
        description="Get in touch with Edraak, India's leading online test series platform for Arabic language competitive exams. Reach out for support, inquiries, or feedback."
        image=""
        url="https://edraakonline.com/contactUs"
      />
      <div className="nav-content">
        <h1>Contact Us</h1>
        <Link className='navHome' to="/">Home <span>» Contact Us</span></Link>
      </div>

      <section className="contact-section">
        <div className="contact-container">
          {/* Left: Contact Info */}
          <div className="contact-info">
            <div className="info-block">
              <MapPin className="icon" />
              <div>
                <h4>Address</h4>
                <p>
                  W W_VO/60,68/1523, 5th Floor, CM Mathew Brothers Arcade, Near Westway hotel, Chakkorathukulam, Calicat-673011
                </p>
              </div>
            </div>

            <div className="info-block">
              <Phone className="icon" />
              <div>
                <h4>Phone</h4>
                <p>+91 8891019991<br />+91 8891019993</p>
              </div>
            </div>

            <div className="info-block">
              <Mail className="icon" />
              <div>
                <h4>Email</h4>
                <p>info@edraakonline.com</p>
              </div>
            </div>

            <div className="social-icons">
              <a href="https://edraakonline.com" target="_blank" rel="noopener noreferrer"><Globe size={18} /></a>
              <a href="https://www.facebook.com/people/Edraakonline/61555049145245/" target="_blank" rel="noopener noreferrer"><Facebook size={18} /></a>
              <a href="https://youtube.com/@edraakonline" target="_blank" rel="noopener noreferrer"><Youtube size={18} /></a>
              <a href="https://instagram.com/edraakonline" target="_blank" rel="noopener noreferrer"><Instagram size={18} /></a>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="contact-form">
            <form>
              <div className="form-row">
                <input type="text" placeholder="Your Name *" required />
                <input type="email" placeholder="Email *" required />
              </div>
              <input type="text" placeholder="Qualification" />
              <textarea placeholder="Message..." rows="4"></textarea>
              <button type="submit">SEND A MESSAGE</button>
            </form>
          </div>
        </div>
      </section>

      <div className="googleMap-view">
        <div style={{ width: '100%', height: '450px', overflow: 'hidden' }}>
          <iframe
            // src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=CM%20Mathew%20Brothers%20Arcade,%20Chakkorathukulam,%20Calicut-673011&t=&z=15&ie=UTF8&iwloc=B&output=embed"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d254.26124284994077!2d75.7722241979663!3d11.276359765008618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba65f94afe5e691%3A0x78b03f8723012a99!2sWORK%20WELL%20COWORKING!5e1!3m2!1sen!2sin!4v1782282934417!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map Location"
          ></iframe>
        </div>
      </div>
    </div>
  )
}

export default ContactUs